import { z } from 'zod';
import { SearchSchema } from '@anytag/shared-validations';
import { SupportedSocialMediaType } from '@anytag/shared-types';
import { SocialAccountType, XhsPostType } from '@anytag/graphql';
import { YtTagRankingFilterSchema, YtTagRankingSearchSchema } from '../ProfilePostsList';
import { InfluencerPromotionMethodsType } from './types';

export const InfluencerAccountSearchSchema = SearchSchema.create({
  filter: {
    schema: z
      .object({
        id: SearchSchema.types.string(),
        lastUpdated: SearchSchema.types.string(),
        sm: z
          .union([
            z.nativeEnum(SupportedSocialMediaType),
            z.nativeEnum(InfluencerPromotionMethodsType),
            z.nativeEnum(SocialAccountType)
          ])
          .or(z.literal(''))
          .default('')
          .catch(''),
        xhsPostType: SearchSchema.types.enum(XhsPostType)
      })
      .merge(YtTagRankingFilterSchema),
    defaultValues: { xhsPostType: XhsPostType.NORMAL }
  }
}).merge(YtTagRankingSearchSchema.pick({ sort: true, limit: true, page: true }));

export type InfluencerAccountSearchSchemaType = z.infer<typeof InfluencerAccountSearchSchema>;
